var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "box" }, [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Editar serie documental"),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-1" }, [
          _vm._v(_vm._s(_vm.serie.nombre)),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v(_vm._s(_vm.serie.descripcion))]),
          _vm._v(" "),
          _c("p", { staticClass: "is-size-7" }, [
            _vm._v("Última edición: " + _vm._s(_vm.serie.created_at)),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "router-link",
              {
                staticClass: "button is-outlined is-primary",
                attrs: {
                  to: {
                    name: "organizacionVerSerieDocumental",
                    params: { idSerie: _vm.serie.id },
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-reply" }),
                _vm._v(" Desactivar edición\n      "),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      this.$route.query.creado
        ? _c("div", { staticClass: "notification is-link animated flash" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
          ])
        : _vm._e(),
      _vm._v(" "),
      this.$route.query.creado
        ? _c("editar-eventos", {
            ref: "editarEventos",
            on: {
              crearEvento: _vm.crearEvento,
              deleteEvento: _vm.deleteEvento,
              editarAccion: _vm.editarAccion,
              editarEvento: _vm.editarEvento,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("editar-datos", { ref: "editDatos", on: { submit: _vm.submitEdit } }),
      _vm._v(" "),
      _c("editar-aspectos", {
        ref: "editAspectos",
        on: { deleteAspecto: _vm.deleteAspecto, addAspecto: _vm.addAspecto },
      }),
      _vm._v(" "),
      _c("editar-estados", {
        ref: "editEstados",
        on: {
          submitEstado: _vm.submitEstado,
          submitEstadoInicial: _vm.submitEstadoInicial,
          deleteEstado: _vm.deleteEstado,
          editarNombreEstado: _vm.editarNombreEstado,
        },
      }),
      _vm._v(" "),
      _c("editar-subunidades", {
        ref: "editSubunidad",
        on: {
          submitSubunidad: _vm.submitSubunidad,
          submitEditarNombreSubunidad: _vm.submitEditarNombreSubunidad,
          deleteSubunidad: _vm.deleteSubunidad,
        },
      }),
      _vm._v(" "),
      !this.$route.query.creado
        ? _c("editar-eventos", {
            ref: "editarEventos",
            on: {
              crearEvento: _vm.crearEvento,
              deleteEvento: _vm.deleteEvento,
              nuevaAccion: _vm.nuevaAccion,
              editarAccion: _vm.editarAccion,
              deleteAccionEvento: _vm.deleteAccionEvento,
              editarEvento: _vm.editarEvento,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", { staticClass: "title is-5" }, [
      _c("i", { staticClass: "fas fa-check-circle" }),
      _vm._v(" ¡Felicidades! ¡La serie ha sido creada!"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("El próximo paso es crear los eventos de la serie.")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          " Para eso, comience a crear Eventos sus acciones en la sección "
        ),
        _c("b", [_vm._v('"Eventos de la serie"')]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }